module.exports = __webpack_public_path__ + "static/media/2.6849a7dd.jpg";